import { render, staticRenderFns } from "./CreateWithdrawRequest.vue?vue&type=template&id=b5607f8e&scoped=true&"
import script from "./CreateWithdrawRequest.vue?vue&type=script&lang=js&"
export * from "./CreateWithdrawRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5607f8e",
  null
  
)

export default component.exports